import React, { Component } from 'react';
import SidebarComponent from '../../components/sidebar/SidebarComponent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'

import Profile from '../../classes/profile'
import {
    fetchHomepageIfNeeded,
    setSelectedSidebarNav,
    fetchThreadIfNeeded,
    fetchChatIfNeeded,
    logout
} from '../../actions'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

import ChatBotComponent from '../../components/aiinsights/ChatBotComponent'

class ChatBotContainer extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    topicId: PropTypes.string,
    homepage: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    fetchHomepage: PropTypes.func.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    selectedDate: PropTypes.string,
    selectedView: PropTypes.string,
    threadId: PropTypes.string,
    messages: PropTypes.array,
    fetchThreadId: PropTypes.func,
    sendMessage: PropTypes.func,
    isFetching: PropTypes.bool,
    apiError: PropTypes.string
  }

  componentDidMount () {
    this.fetchData ()
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
  }

  render () {
    const { profile, location, shortcut, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, threadId, messages, sendMessage, isFetching, apiError } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()

    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          shortcut={shortcut}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <ChatBotComponent
          isAdmin={this.props.isAdmin}
          homepage={homepage ? homepage : this.props.homepage}
          profile={profile}
          shortcut={shortcut}
          threadId={threadId}
          messages={messages}
          sendMessage={sendMessage}
          isFetching={isFetching}
          apiError={apiError}
          fetchThreadId={this.props.fetchThreadId}
        />
      </>
    )
  }
}

function mapStateToProps () {
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const selectedDate = state.globalAttentionIndex.selectedDate
    const selectedView = state.globalAttentionIndex.selectedView
    const threadId = state.chat.threadId
    const messages = state.chat.messages
    const isFetching = state.chat.isFetching
    const apiError = state.chat.chatError

    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      selectedDate,
      selectedView,
      isAIInsights,
      threadId,
      messages,
      isFetching,
      apiError
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    fetchThreadId: (assistantId, user) => dispatch(fetchThreadIfNeeded(assistantId, user)),
    sendMessage: (message, threadId, assistantId, isBurner, burnerId, user) => dispatch(fetchChatIfNeeded(message, threadId, assistantId, isBurner, burnerId, user)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatBotContainer)